import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activeOnbeDowntimeWindow: state.cms.activeOnbeDowntimeWindow,
});

angular
  .module('myConsultApp')
  .controller(
    'onbeDowntimeWindowCreateEditController',
    ($ngRedux, $rootScope, $scope, $timeout, $http, ENV) => {
      $scope.initData = () => {
        $scope.daysOfWeek = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ]
        $scope.currentOnbeDowntimeWindow = {
          weekday_array: [],
          start_time_et: '',
          end_time_et: '',
        };
        $scope.onbeDowntimeWindowProcessing = false;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };
        $scope.title = 'ADD ONBE DOWNTIME WINDOW';
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.applyError = (error) => {
        const errorData = error.data['onbe-downtime-windows'];
        const details = [];

        Object.keys(errorData).map((key) => {
          if (typeof errorData[key] === 'string') {
            $scope.error.highlightedFields[key] = [errorData[key]];
          } else if (Array.isArray(errorData[key])) {
            $scope.error.highlightedFields[key] = errorData[key];
          } else {
            $scope.error.highlightedFields[key] = Object.values(errorData[key]);
          }
        });

        if (error.status === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (error.status === 400) {
          if (Object.keys($scope.error.highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else {
          details.push(error.statusText);
        }
        $scope.error.details = details;
      };
      
      $scope.applySuccess = (keepPage = false) => {
        $scope.close();
        $rootScope.getData(keepPage);
      };

      $scope.deleteEntry = () => {
        if ($scope.currentOnbeDowntimeWindow.id) {
          $scope.onbeDowntimeWindowProcessing = true;
          $scope
            .deleteOnbeDowntimeWindow($http, ENV, $scope.currentOnbeDowntimeWindow.id)
            .then(() => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applySuccess(true);
                $scope.getData();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.submitOnbeDowntimeWindow = () => {
        const payload = {
          'onbe-downtime-windows': $scope.currentOnbeDowntimeWindow,
        };
        const currentOnbeDowntimeWindowId = $scope.currentOnbeDowntimeWindow.id;
        $scope.onbeDowntimeWindowProcessing = true;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };

        if (!$scope.currentOnbeDowntimeWindow.id) {
          $scope
            .createOnbeDowntimeWindow($http, ENV, payload)
            .then(() => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applySuccess();
                $scope.getData();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applyError(error);
              });
            });
        } else {
          $scope
            .updateOnbeDowntimeWindow($http, ENV, currentOnbeDowntimeWindowId, payload)
            .then(() => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applySuccess(true);
                $scope.getData();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.onbeDowntimeWindowProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.selectDayOfWeek = (day) => {
        const index = $scope.currentOnbeDowntimeWindow.weekday_array.indexOf(day);
        if (index > -1) { // only splice array when item is found
          $scope.currentOnbeDowntimeWindow.weekday_array.splice(index, 1); // 2nd parameter means remove one item only
        } else {
          $scope.currentOnbeDowntimeWindow.weekday_array.push(day);
        }
      }

      $scope.checkDayOfWeek = (day) => {
        var dayOfWeekChecked = false;
        angular.forEach($scope.currentOnbeDowntimeWindow.weekday_array, function (value, key) {
          if(day == value){
            dayOfWeekChecked = true;
          }
        });
        return dayOfWeekChecked;
      };

      $scope.close = () => {
        $scope.setOnbeDowntimeWindow(null);
        $rootScope.closeComponent();
      };

      $scope.clearForm = () => {
        if ($scope.onbeDowntimeWindowForm) {
          $scope.onbeDowntimeWindow.$setUntouched();
          $scope.onbeDowntimeWindow.$setPristine();
        }
      };

      $scope.$watch('activeOnbeDowntimeWindow', () => {
        if ($scope.activeOnbeDowntimeWindow) {
          $scope.title = 'EDIT ONBE DOWNTIME WINDOW';
          $scope.currentOnbeDowntimeWindow = angular.copy($scope.activeOnbeDowntimeWindow);
        } else {
          $scope.initData();
        }
      });

      $scope.$watch('subComponent', (newValue, oldValue) => {
        if (oldValue === 'create-onbe-downtime-window' || oldValue === 'edit-onbe-downtime-window') {
          $scope.initData();
          $scope.clearForm();
        }
      });

      $scope.init();
      $scope.initData();
      $scope.$on('$destroy', $scope.unsubscribe);
    },
  )
  .directive('onbeDowntimeWindowCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/onbe-downtime-window-create-edit.html',
    };
  });
